import React from 'react';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { TableContract } from '@/components/admin/TableContract'; // 申し込みテーブルをインポート

export const Contract: React.FC = () => {
  return (
    <AdminLayout>
      <h2 className="text-xl font-bold mb-20">申し込みを管理</h2>
      <TableContract />
    </AdminLayout>
  );
};
